import { e } from "./engine-user-agent.js";
var r = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(e);
export { r as s };